import { LogIn } from 'lucide-react'
import { Boton } from '../../components/kit'
import { APP_NOMBRE } from '../../config'
import { useAuth } from '../../contexts/AuthProvider'

/** Portada pública. Reemplaza este contenido por la presentación de tu aplicación. */
export default function InicioPublico() {
  const { conSesion } = useAuth()
  return (
    <section className="portada">
      <p className="dcc-t-heading-s portada__antetitulo">Departamento de Ciencias de la Computación</p>
      <h1 className="dcc-t-heading-l">{APP_NOMBRE}</h1>
      <p className="dcc-t-body-l portada__bajada">
        Describe aquí, en una o dos líneas, para qué sirve la aplicación y a quién está dirigida.
      </p>
      {conSesion ? <Boton tam="lg" to="/app">Ir a la aplicación</Boton> : <Boton tam="lg" icono={LogIn} to="/login">Entrar</Boton>}
    </section>
  )
}
